<template>
  <div>
    <!-- 第一步选择机构 -->
    <AgencyList v-if="step === 1"/>
    <!-- 第二步，选择带队教练 -->
    <StaffList ref="staffList" v-if="step === 2"/>
    <!-- 第三步，选择参数队员 -->
    <StepThree v-if="step === 3" @stepThreeJoinCombatDetailSuccess="signData"/>
    <!-- 第四步，查看报名数据 -->
    <StepFour ref="stepFour" v-if="step === 4" @payOver="payOver"/>
    <!-- 第五步，下载凭证 -->
    <PaySuccess ref="paySuccess" v-if="step === 5"></PaySuccess>
    <div class="btnContent">
      <div class="btn top20" @click="signup()" v-if="step === 4 || step === 5">继续报名</div>
      <div class="btn top20" @click="lastStep()" v-if="step > 1 && step !== 4 && step !== 5">上一步</div>
      <div class="btn top20" @click="nextStep()" v-if="step < 4 && step != 3">下一步</div>
      <div class="btn top20" @click="signData()" v-if="step > 1 && step < 4">查看报名数据</div>
      <div class="btn top20" @click="downloadData()" v-if="step === 4">下载凭证</div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import AgencyList from '../agency/AgencyList'
import StaffList from '../staff/StaffList'
import StepThree from './StepThree'
import StepFour from './StepFour'
import PaySuccess from '@comm/components/join/pay/PaySuccess'
export default {
  components: {
    AgencyList,
    StaffList,
    StepThree,
    StepFour,
    PaySuccess
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      agencyId: this.$route.query.agencyId || null,
      step: Number(this.$route.query.step || 1)
    }
  },
  computed: {
    ...mapState({
      joinAgency: state => state.join.joinAgency
    })
  },
  methods: {
    lastStep () {
      // 修改地址参数
      switch (this.step) {
      case 2:
        this.step = 1
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 1}})
        break
      case 3:
        this.step = 2
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 2, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        break
      case 4:
        this.step = 3
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        break
      }
    },
    nextStep () {
      switch (this.step) {
      case 1:
        if (this.joinAgency.agencyId === null) {
          this.$message.error('请选择单位')
          return
        }
        this.step = 2
        this.$api.join.getMatchTeam({agencyId: this.joinAgency.agencyId, programId: 0}).then(res => {
          if (res.data && res.status === 0) {
            this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 2, agencyId: this.joinAgency.agencyId, teamId: res.data[0].id}})
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          console.log(err)
        })
        break
      case 2:
        let data = this.$refs.staffList.getChoiceCoach()
        if (data.result) {
          if (data.leaderIds !== '' && data.leaderIds !== '-1') {
            this.$api.join.LeaderStaffAddOrUpdate({staffIds: data.leaderIds, matchId: this.matchId, teamId: this.$route.query.teamId}).then(res => {
            }).catch(err => {
              console.log(err)
            })
          }
          store.commit('join/JOIN_CHANGE_COACH_ID', data.leaderIds)
          this.step = 3
          this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        } else {
          this.$message.error(data.content)
        }
        break
      case 3:
        this.step = 4
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 4, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
        break
      }
    },
    // 继续报名
    signup () {
      this.step = 3
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
    },
    signData () {
      this.step = 4
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 4, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
    },
    downloadData () {
      this.$refs.stepFour.paySuccess(true)
    },
    payOver () {
      this.step = 5
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 5, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
    }
  }
}
</script>
<style lang="scss" scoped>
  .btnContent {
    text-align: center;
    .btn{
      color: #fff;
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin: 0 auto;
      right: 250px;
      bottom: 29px;
      text-align: center;
      border-radius: 2px;
      background-color: #b80000;
      cursor:pointer;
      display: inline-block;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .top20 {
      margin-top: 20px;
    }
    .left20 {
      margin-left: 20px;
    }
    .right20 {
      margin-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/smallBall/SmallBallJoin.vue